import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import MealTooltip from './MealTooltip';
import ActivityTooltip from './ActivityTooltip';
import PillTooltip from './PillTooltip';
import InjectionTooltip from './InjectionTooltip';
import styles from './RelatedData.pcss';
const RelatedData = ({ element })=>{
    useStyles(styles);
    let relatedDataTooltip;
    switch(element.type){
        case 'food':
            relatedDataTooltip = /*#__PURE__*/ _jsx(MealTooltip, {
                element: element
            });
            break;
        case 'activity':
            relatedDataTooltip = /*#__PURE__*/ _jsx(ActivityTooltip, {
                element: element
            });
            break;
        case 'pill':
            relatedDataTooltip = /*#__PURE__*/ _jsx(PillTooltip, {
                element: element
            });
            break;
        case 'injection':
            relatedDataTooltip = /*#__PURE__*/ _jsx(InjectionTooltip, {
                element: element
            });
            break;
        default:
            relatedDataTooltip = null;
    }
    return /*#__PURE__*/ _jsx("div", {
        children: relatedDataTooltip
    });
};
export default /*#__PURE__*/ memo(RelatedData);
